/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updates_Newupdateavailable2Inputs */

const tr_updates_newupdateavailable2 = /** @type {(inputs: Updates_Newupdateavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni Güncelleme Mevcut!`)
};

const en_updates_newupdateavailable2 = /** @type {(inputs: Updates_Newupdateavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Update Available!`)
};

/**
* | output |
* | --- |
* | "New Update Available!" |
*
* @param {Updates_Newupdateavailable2Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const updates_newupdateavailable2 = /** @type {((inputs?: Updates_Newupdateavailable2Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Newupdateavailable2Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_updates_newupdateavailable2(inputs)
	return en_updates_newupdateavailable2(inputs)
});
export { updates_newupdateavailable2 as "updates_newUpdateAvailable" }